/**
 * PostMessage protocol constants for communication between the FanFest
 * embedded frontend iframe and the host-page SDK.
 *
 * Shared between `apps/frontend` (sender/receiver inside the iframe) and
 * `apps/sdk` (sender/receiver on the host page).
 */

/** Envelope `type` field for all embed postMessages. */
export const EMBED_MESSAGE_EVENT_NAME = "fanfest:embed-message" as const;

/** Discriminator values for `data.type` inside an embed message envelope. */
export enum EmbedMessageType {
  /** Iframe → SDK: handshake signal (safe to send with "*" origin). */
  EmbedReady = "embed-ready",
  /** SDK → Iframe: push auth state (JWT, identifiers, integration mode). */
  Authentication = "authentication",
  /** Iframe → SDK: user identified after signup/login inside the iframe. */
  AuthenticationFinished = "authentication-finished",
  /** Iframe → SDK: user logged out inside the iframe. */
  Logout = "logout",
  /** Iframe → SDK: a modal opened or closed inside the iframe. */
  ModalStateChanged = "modal-state-changed",
  /** Iframe → SDK: request to change the iframe display mode. */
  DisplayModeChanged = "display-mode-changed",
}
